<template>
	<div>
		<Sticky 
			v-bind:offset='0.5'
			triggerClass='step'
			ActiveClass='entered'
			v-on:enterFn="handleEnterFn">

			<!-- sticky graphic -->
			<template v-slot:sticky>
				<div>
					<Map :userLoc="userLoc" :step="step" />
				</div>
			</template>
			
			<template v-slot:steps>
				<div 
					v-for="(stap, index) in content" 
					:key="'stap-' + index"
					:data-index="index"
					class="step">
					<div v-if="stap.tekst" class="tekstvak">
						<span v-html="parseTekst(stap)"></span>
						<div 
							v-if="buurtScenario === 'daling' && stap.alternatief" 
							class="buurt-button"
							@click="buurtScenarioStijging">
							hier
						</div>
					</div>
					<div v-else class="map-img-wrap">
						<img class="step-img" :src="require('@/assets/' + stap.img)" alt="" />
					</div>
				</div>
			</template>
		</Sticky>
	</div>
</template>

<script>
import Map from './map';
import Sticky from './knd-sticky';

export default {
	name: 'MapStory',
	props: ['content', 'userLoc'],
	components: {
		Map,
		Sticky
	},
	data() {
		return {
			step: 1,
			startGrey: '<span class="highlightGrey">',
			startRed: '<span class="highlightRed">',
			startBlue: '<span class="highlightBlue">',
			startYellow: '<span class="highlightYellow">',
			end: '</span>',
			showChoice: false
		}
	},
	computed: {
		buurtSelected() {
			return this.$store.getters.buurtSelected;
		},

		buurtScenario() {
			return this.$store.getters.buurtScenario;	
		},

		gemeenteSelected() {
			return this.$store.getters.gemeenteSelected;
		},

		mapData() {
			return this.$store.getters.mapData;
		},

		buurtNaam() {
			return this.startBlue + this.buurtSelected.buurt_naam + this.end;
		},

		gemeenteNaam() {
			return this.startBlue + this.gemeenteSelected.gemeente_naam + this.end;
		},

		buurtVers2011() {
			if (this.buurtSelected.buurt_vers_2011 === 1) {
				return this.startYellow + this.buurtSelected.buurt_vers_2011 + " kleinere winkel was" + this.end;	
			}
			return this.startYellow + this.buurtSelected.buurt_vers_2011 + " kleinere winkels waren" + this.end;
		},

		buurtOngezond2011() {
			if (this.buurtSelected.buurt_ongezond_2011 === 1) {
				return this.startGrey + this.buurtSelected.buurt_ongezond_2011 + " verkooppunt verkocht" + this.end;
			}
			return this.startGrey + this.buurtSelected.buurt_ongezond_2011 + " verkooppunten verkochten" + this.end;
		},

		buurtVersVerschil() {
			let vervang = this.buurtSelected.buurt_vers_verschil;
			vervang = !isNaN(parseInt(vervang)) ? Math.abs(parseInt(vervang)) : vervang;
			if (vervang === 1) {
				return this.startYellow + "is " + vervang + " winkel" + this.end;
			}
			return this.startYellow + "zijn " + vervang + " winkels" + this.end;
		},

		buurtVersVerschilBijAf() {
			let vervang = this.buurtSelected.buurt_vers_verschil > 0 ? " bijgekomen" : " verdwenen";
			return this.startYellow + vervang + this.end;
		},

		buurtOngezondVerschil() {
			let vervang = this.buurtSelected.buurt_ongezond_verschil;
			vervang = !isNaN(parseInt(vervang)) ? Math.abs(parseInt(vervang)) : vervang;
			let bijAf = this.buurtSelected.buurt_ongezond_verschil > 0 ? " bijgekomen" : " verdwenen";
			if (vervang === 1) {
				return this.startRed + "is er " + vervang + " verkooppunt" + bijAf + this.end;
			}
			return this.startRed + "zijn er " + vervang + " verkooppunten" + bijAf + this.end;
		},

		buurtOngezondVerschilStijging() {
			let vervang = this.buurtSelected.buurt_ongezond_verschil > 0 ? "stijging" : "daling";
			return this.startRed + vervang + this.end;
		},

		buurtOngezondVerschilPercentage() {
			let vervang = Math.round(this.buurtSelected.buurt_ongezond_verschil_percentage);
			return this.startRed + vervang + this.end;
		},

		gemeenteOngezond2011() {
			let vervang = this.gemeenteSelected.gemeente_ongezond_2011;
			if (vervang > 1) {
				return this.startGrey + vervang + " verkooppunten" + this.end;
			}
			else {
				return this.startGrey + vervang + " verkooppunt" + this.end;	
			}
		},

		gemeenteOngezond2021() {
			let vervang = this.gemeenteSelected.gemeente_ongezond_2021;
			if (vervang > 1) {
				return this.startRed + "zijn er" + this.end + " in 2021 " + this.startRed + vervang + " verkooppunten" + this.end;	
			}
			else {
				return this.startRed + "is er in 2021 " + vervang + " verkooppunt" + this.end;
			}
		},

		gemeenteOngezondStijging() {
			let vervang = this.gemeenteSelected.gemeente_ongezond_verschil > 0 ? "stijging" : "daling";
			return this.startRed + vervang + this.end;
		},

		gemeenteOngezondVerschilPercentage() {
			let vervang = Math.round(this.gemeenteSelected.gemeente_ongezond_verschil_percentage);
			return this.startRed + vervang + this.end;
		},

		gemeenteVers2011() {
			if (this.gemeenteSelected.gemeente_vers_2011 === 1) {
				return this.startYellow + this.gemeenteSelected.gemeente_vers_2011 + " kleinere winkel was" + this.end;	
			}
			return this.startYellow + this.gemeenteSelected.gemeente_vers_2011 + " kleinere winkels waren" + this.end;
		},

		gemeenteVersVerschil() {
			let vervang = this.gemeenteSelected.gemeente_vers_verschil;
			vervang = !isNaN(parseInt(vervang)) ? Math.abs(parseInt(vervang)) : vervang;
			if (vervang === 1) {
				return this.startYellow + "is " + vervang + " winkel" + this.end;
			}
			return this.startYellow + "zijn " + vervang + " winkels" + this.end;
		},

		gemeenteVersVerschilBijAf() {
			let vervang = this.gemeenteSelected.gemeente_vers_verschil > 0 ? " bijgekomen" : " verdwenen";
			return this.startYellow + vervang + this.end;
		}
	},
	methods: {
		handleEnterFn(el) {
			let currentNum = +el.dataset.index + 1;
			this.step = currentNum;
		},

		parseTekst(stap) {
			if (this.buurtSelected !== null) {
				let tekst = stap.tekst;

				if (this.buurtScenario === "daling" && stap.alternatief) {
					tekst = stap.alternatief;
				}

				return tekst.replace(/\{\{(.*?)\}\}/g, (match, token) => {
					return this[token];
				});
			}
			else {
				return "";
			}
		},

		buurtScenarioStijging() {
			this.$store.dispatch('updateBuurtScenario', "stijging");
		}
	}
}
</script>